import { getBackboneWindow } from '@opallabs/brown-dwarf'
import { testFeature } from '@opallabs/principles'
import * as styles from './styles'

export const InviteLinkModalTrigger: React.FC<{
  onInviteLinkClick: () => void
}> = ({ onInviteLinkClick }) => {
  const onClick = () => {
    onInviteLinkClick()
    parent.postMessage({ message: 'asgard:invite_link_modal:open' }, '*')
  }

  const userRole =
    getBackboneWindow() && getBackboneWindow()?.Opal?.State?.this_user_role

  const showButton =
    testFeature('invite_link') &&
    (testFeature('users_can_invite') ||
      ['opal_admin', 'admin'].includes(userRole || ''))

  return showButton ? (
    <button
      aria-haspopup="dialog"
      css={styles.buttonStyles()}
      onClick={onClick}
    >
      Invite people via link instead.
    </button>
  ) : null
}
